import React from 'react';
import PropTypes from 'prop-types';

export const ArrowOut = ({ width, height, ...props }) => (
  <svg
    data-icon='arrow-out'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M11 20V7.825l-5.6 5.6L4 12l8-8 8 8-1.4 1.425-5.6-5.6V20h-2Z'
    />
  </svg>
);

ArrowOut.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowOut.defaultProps = {
  width: 24,
  height: 24,
};
